import {DynForm} from '../domain/meta/dyn-form';
import * as actions from './form-editor.actions';
import {createSelector} from '@ngrx/store';

export interface State {
    formValue: any;
    formStatus: boolean;
    updated: boolean;
    form: DynForm;
}

export const initialState: State = {
    formValue: null,
    formStatus: false,
    updated: false,
    form: null
};

export function reducer (
    state: State = initialState,
    action: actions.FormEditorActions
): State {
    
    switch (action.type) {
        case actions.UPDATE:
            return {
                ...state,
                formValue: action.payload.value,
                formStatus: action.payload.status,
                updated: false
            };
        case actions.BUILD_FORM_SUCCESS:
            return {
                ...state,
                form: action.form,
                updated: true
            };
        case actions.RESET_FORM:
            return initialState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/state/form-editor.reducer.ts